import { h, Fragment } from "preact";
import { useState } from "preact/hooks";
import moment from "moment";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Select,
  Space,
  Tooltip,
  Typography,
} from "antd";
import {
  DownloadOutlined,
  LoadingOutlined,
  CloudDownloadOutlined,
} from "@ant-design/icons";
import { getDefaultStateParams } from "./TransactionsUtils";
import { getBuffer, getMimeType, saveFile } from "./TransactionsDownloadUtils";
import useTransactionsDownload from "./useTransactionsDownload";

export default function TransactionsDownloadSection(props) {
  const filters = props.propData;

  const { isLoading, batchSize, bufferSize, fetchFile, fetchStatistics } =
    useTransactionsDownload();

  const { queryParams, fileDownloadParams } = getDefaultStateParams();

  const initialState = {
    dateFrom: queryParams.defaultDateFrom.unix(),
    dateTo: queryParams.defaultDateTo.unix(),
    serviceName: "transactions",
    fileExtension: fileDownloadParams.defaultFileExtension,
  };

  const [currentState, setCurrentState] = useState(initialState);

  const disabledDate = (current) => current > moment();

  const onDateChange = (date) => {
    const dateFrom = date.startOf("month").unix();
    const dateTo = date.endOf("month").unix();

    setCurrentState({ ...currentState, dateFrom, dateTo });
  };

  const onServiceChange = (selectedService) => {
    setCurrentState({ ...currentState, serviceName: selectedService });
  };

  const onFileExtensionChange = (selectedFileExtension) => {
    setCurrentState({ ...currentState, fileExtension: selectedFileExtension });
  };

  const DownloadButtonIcon = () => {
    return isLoading ? (
      <LoadingOutlined spin />
    ) : (
      <CloudDownloadOutlined style={{ fontSize: "20px" }} />
    );
  };

  const DownloadButtonLabel = () => {
    if (!isLoading) return "Download .xlsx";

    let estimatedSize = (batchSize / bufferSize) * 100;
    if (!isFinite(estimatedSize)) estimatedSize = 0;
    estimatedSize = `${estimatedSize.toFixed(1)}%`;

    return estimatedSize;
  };

  const onDownloadButtonClick = async (event) => {
    const { dateFrom, dateTo, serviceName, fileExtension } = currentState;
    const rawData = await fetchFile({ params: filters });
    const statistics = await fetchStatistics({ params: {
        dateFrom: filters.dateFrom,
        dateTo: filters.dateTo,
      },
    });
    const buffer = await getBuffer(serviceName, rawData, fileExtension, statistics);
    const mimeType = getMimeType(fileExtension);
    const filename = `${serviceName}_${filters.dateFrom}_${filters.dateTo}.${fileExtension}`;
    saveFile(buffer, filename, mimeType);
  };

  return (
    <>
    <Tooltip title='Export Transactions to Excel (.xlsx)'
             placement="bottom"
    >
      <Button
        disabled={isLoading}
        type="outline"
        shape="round"
        onClick={onDownloadButtonClick}
        id="downloadButton"
        // loading={isLoading}
        style={{ width: "55px" }}
      >
        {/* <Space>
          <DownloadButtonIcon />
          <DownloadButtonLabel />
        </Space> */}
        <Space>
          {/* <DownloadOutlined />
          <span>Download xlsx</span> */}
          <DownloadButtonIcon />
        </Space>
      </Button>
      </Tooltip>
      {/* <Card
        bordered={false}
        headStyle={{
          borderBottom: "none",
        }}
        title={<Typography.Title level={4}>Downloads</Typography.Title>}
      >
        <Form className="report__form" layout="inline" autoComplete="off">
          <Col flex={1}>
                        <Form.Item>
                            <Select
                                className="report__form-select"
                                defaultValue="veridoc"
                                onChange={onServiceChange}
                                style={{ width: "100%" }}
                            >
                                <Select.Option value="veridoc">
                                    Document recognition
                                </Select.Option>
                                <Select.Option value="veriface">
                                    Face Recognition
                                </Select.Option>
                                <Select.Option value="verilive">
                                    Liveness detection
                                </Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col flex="none">
                        <Form.Item>
                            <Select
                                className="report__form-select"
                                defaultValue={fileDownloadParams.defaultFileExtension}
                                onChange={onFileExtensionChange}
                            >
                                <Select.Option value={"xlsx"}>
                                    .XLSX
                                </Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col flex="none">
                        <Form.Item>
                            <DatePicker
                                defaultValue={queryParams.defaultDateFrom}
                                picker="month"
                                disabledDate={disabledDate}
                                onChange={onDateChange}
                            />
                        </Form.Item>
                    </Col>
          <Col flex="none">
            <Button
              disabled={isLoading}
              type="outline"
              shape="round"
              onClick={onDownloadButtonClick}
              style={{ width: "128px" }}
            >
              <Space>
                <DownloadButtonIcon />
                <DownloadButtonLabel />
              </Space>
            </Button>
          </Col>
        </Form>
      </Card> */}
    </>
  );
}
